module.exports = __webpack_public_path__ + "img/infographicWhoWeAreVertical.c3fe0f50.png";